import { PropsWithChildren, ReactNode } from 'react';
import { Tooltip, TooltipTrigger, TooltipContent } from './primitives/tooltip';
import { cn } from '@/utils/shad';
import { PopperContentProps } from '@radix-ui/react-popper';

export const BasicTooltip = ({
  text,
  children,
  show = true,
  side,
  classNameContent,
  align,
  sideOffset,
}: PropsWithChildren<{
  text: string | ReactNode;
  show?: boolean;
  side?: 'bottom' | 'left' | 'right';
  align?: PopperContentProps['align'];
  classNameContent?: string;
  sideOffset?: number;
}>) => (
  <>
    {show ? (
      <Tooltip delayDuration={200} disableHoverableContent>
        <TooltipTrigger asChild>{children}</TooltipTrigger>
        <TooltipContent side={side} align={align} sideOffset={sideOffset} className={cn('break-all', classNameContent)}>
          {text}
        </TooltipContent>
      </Tooltip>
    ) : (
      children
    )}
  </>
);
